<template>
  <div class="main-page">
    <app-header v-bind:fixed="appScroll"></app-header>
    <error-503 v-if="loading.error"></error-503>
    <div v-else>
      <main-search></main-search>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from './../Header/Header'
import Search from './../Search/Search'
import Error503 from './../Error/503'
import * as UrlService from '../../scripts/modules/url'
import * as mainPageModule from './../../scripts/modules/main-page'

export default {
  name: 'main-page',
  components: {
    'app-header': Header,
    'main-search': Search,
    'error-503': Error503,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App!'
    }
  },
  beforeCreate () {
    //set query search parameters from url
    UrlService.receiveUrl(this.$route.query);
  },
  beforeUpdate () {
    //set query search parameters to url
    this.$router.push(UrlService.dispatchUrl());
  },
  created () {
    mainPageModule.onload()
  },
  computed: {
    ...mapGetters({
      loading: 'GET_LOADING_STATE',
      appScroll: 'GET_APP_SCROLL'
    })
  }
}
</script>



// WEBPACK FOOTER //
// MainPage.vue?4867fb77